import HelpDashboard from '@/pages/help/dashboard'
import ConnectingPaypal from '@/pages/help/articles/connecting-paypal'
import SettingUpVendors from '@/pages/help/articles/setting-up-vendors'
import ConnectingAccounts from '@/pages/help/articles/accounts-to-vendors'

const routes = [
  {
    path: '/help/',
    name: 'helpDashboard',
    component: HelpDashboard
  },
  {
    path: '/help/connecting-accounts-to-vendors',
    name: 'connectingAccounts',
    component: ConnectingAccounts
  },
  {
    path: '/help/connecting-paypal',
    name: 'connectingPaypal',
    component: ConnectingPaypal
  },
  {
    path: '/help/setting-up-vendors',
    name: 'settingUpVendors',
    component: SettingUpVendors
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/pages/help/routes.js